/**
 * 统计-创作方
 */

import StoreDecorator, {
  Action,
  Mutation,
  Getter,
  AutoLoading
} from '@acgn/herm/lib/store-decorator';

import {
  getCreationSummary,
  getCreationChartData,
  getLinkList,
  taskCycleDetail,
  retrialCycleDetail,
  overdueApproveDetail,
  overdueCycleDetail,
  overdueSubDetail,
  targetCycleDetail
} from '../../api/statisticNor';

interface StateType {
}
@StoreDecorator
@AutoLoading
class StoreModule {
  public state() {
    return {};
  }

  // 卡片数据
  @Action()
  public async getCreationSummary(state: StateType, payload: any) {
    return await getCreationSummary(payload);
  }
  // 图表数据
  @Action()
  public async getCreationChartData(state: StateType, payload: any) {
    return await getCreationChartData(payload);
  }
  // 获取创作环节列表
  @Action()
  public async getLinkList(state: StateType, payload: any) {
    return await getLinkList(payload);
  }

  // 任务情况明细
  @Action()
  public async getTaskCycleDetail(state: StateType, payload: any) {
    return await taskCycleDetail(payload);
  }

  // 过审情况明细
  @Action()
  public async getRetrialCycleDetail(state: StateType, payload: any) {
    return await retrialCycleDetail(payload);
  }

  // 逾期审批明细
  @Action()
  public async getOverdueApproveDetail(state: StateType, payload: any) {
    return await overdueApproveDetail(payload);
  }

  // 逾期提交明细
  @Action()
  public async getOverdueSubDetail(state: StateType, payload: any) {
    return await overdueSubDetail(payload);
  }

  // 逾期情况明细
  @Action()
  public async getOverdueCycleDetail(state: StateType, payload: any) {
    return await overdueCycleDetail(payload);
  }

  // 目标情况明细
  @Action()
  public async getTargetCycleDetail(state: StateType, payload: any) {
    return await targetCycleDetail(payload);
  }
}

export default new StoreModule();
